import { gql } from "@apollo/client";

export const GET_FAVOURITE_RECIPES = gql`
query getFavouritesData($userId: uuid = "") {
  User_favourite_recipes(where: {userId: {_eq: $userId}}, order_by: {createdAt: desc}) {
    recipeId
  }
}
`;

export const GET_MOBILE_CREATED_RECIPE = gql`
query getMobileCreatedRecipe($id: uuid = "") {
  User_Generated_Recipes(where: {recipe_Id: {_eq: $id}}) {
    recipeData
  }
}
`

export const GET_INGREDIENTS = gql`
  query GetIngredients {
    Ingredients_DB(order_by: { displayName: asc }) {
      tags
      preps
      nutrientInfo
      image
      iconImage
      displayName
      defaultWeightUnit
      secondaryUnit
      defaultUnitTriggerPoint
      allergens
      approx
      alternateImage
      alternateNames
      conversion
      id: _id
    }
  }
`;

export const GET_RECIPE_FROM_ID = gql`
query getE2RecipeFromId($Recipe_ID: String = "") {
  Recipe_DB_by_pk(Recipe_ID: $Recipe_ID) {
    Active
    Cooking_Time
    Description
    Diet
    Recipe_ID
    Recipe_Name
    author
    cuisine
    editor
    hiddenTags
    image_url
    lastEditedAt
    maxServing
    minServing
    prep_time
    created_source
    created_by
    is_deleted
    is_public
    steps: Steps_DBs(order_by: { Rank: asc }) {
      Rank
      id: StepId
      description
      name
      ingredientsTitle:StepPurpose
      subSteps: SubSteps(order_by: { Rank: asc }) {
        Rank
        name
        parameters
        type
        id: subStepId
      }
    }
  }
}
`;

export const GET_RECIPE_E3_FROM_ID = gql`
query getE3RecipeFromId($id: String = "") {
  Recipes_E3_by_pk(id: $id) {
    active
    author
    created_by
    created_source
    cuisine
    description
    diet
    editor
    id
    is_deleted
    is_public
    hidden_tags
    last_edited_at
    created_at
    updated_at
    meal_type
    name
    recipe_market_price
    Recipe_Variations {
      active
      cooking_time
      default
      description
      id
      image_url
      ingredients
      max_serving
      metadata
      min_serving
      name
      parameters
      prep_time
      recipe_id
      tags
      RecipeVariations_Steps(order_by: {step_rank: asc}) {
        id
        recipeVariation_id
        step_id
        step_rank
        StepsE3 {
          description
          id
          name
          updated_at
          step_purpose
          Steps_Substeps(order_by: {subStep_rank: asc}) {
            id
            step_id
            subStep_id
            subStep_rank
            SubstepsE3 {
              id
              media
              name
              parameters
              type
              created_at
              updated_at
              Recipe_Presets {
                id
                image
                name
                subStepId
              }
              SubSteps_Ingredients_E3s {
                id
                ingredient_id
                subStep_id
              }
            }
          }
        }
      }
    }
  }
}

`
export const GET_USER_LINKED = gql`
query GetUserLinked($userId: uuid = "") {
  devices(where: {userByUser: {id: {_eq: $userId}}}) {
    userByUser {
      email
      id
    }
  }
}
`

export const FIND_USER_BY_ID = gql`
  query MObApp_FindUSerByID($_eq: String = "") {
    users(where: {userId: {_eq: $_eq}}) {
      id
      email
      userId
      inactive
      nickName
      photoURL
      createdAt
      updated_at
      userSettings
      userAppSettings
      userRecos
      phone
      fcmTokens:fcm_tokens 
      devices {
        _id
        displayName
        metadata:__metadata
      }
    }
  }
`;

export const GET_TEMPLATE_RECIPES = gql`
query getTemplateRecipes {
  Recipes_E3(where: {hidden_tags: {_contains: "template"}}) {
    id
  }
}
`
export const GET_RECIPE_PRESETS = gql`
query RECIPE_PRESETS {
  Recipe_Presets {
    id
    image
    name
    subStepId
    SubstepsE3 {
      created_at
      id
      media
      name
      parameters
      type
      updated_at
    }
  }
}
`
export const NEW_GET_INGREDIENTS = `
  Ingredients_DB(order_by: {displayName: asc}, where: {created_source: {_eq: "recipeAdmin"}}) {
    tags
    preps
    nutrientInfo
    image
    iconImage
    displayName
    defaultWeightUnit
    secondaryUnit
    defaultUnitTriggerPoint
    allergens
    approx
    alternateImage
    alternateNames
    conversion
    id: _id
    created_source
  }`

export const FETCH_FILTERED_RECIPES = gql`
  query FETCH_FILTERED_RECIPES($filter_conditions: [Recipes_E3_bool_exp!] = {}) {
    Recipes_E3(where: { _and: $filter_conditions } ) {
      id
      name
      cuisine
      diet
      meal_type
      created_at
      updatedAt: updated_at
      lastEditedAt: last_edited_at
      Recipe_Variations {
        cooking_time
        default
        image_url
        prep_time
        ingredients
      }
    Recipe_Categories_Map {
      Category_ID
      Recipe_ID
      mapRank:map_rank
    }
  }
}
`;

export const FETCH_PUBLIC_RECIPES = gql`
query FETCH_PUBLIC_RECIPES {
  Recipes_E3(where: {is_public: {_eq: true}, is_deleted: {_eq: false}}) {
    id
    name
    cuisine
    diet
    meal_type
    Recipe_Variations {
      cooking_time
      default
      image_url
      prep_time
      ingredients
    }
  }
}
`;

export const FETCH_USER_CREATED_FAVORITE_RECIPES = gql`
  query FETCH_USER_CREATED_FAVORITE_RECIPES($missingIDs: [String!] = "") {
    Recipes_E3(where: {id: {_in: $missingIDs}}) {
      name
      Recipe_Variations {
        cookTime: cooking_time
        default
        url: image_url
        ingredientsListIds: ingredients
        prepTime: prep_time
      }
      tags: cuisine
      categories: diet
      id
      mealType: meal_type
    }
  }
`

export const FETCH_RECIPE_IDS_BY_CATEGORY_ID = gql`
  query FETCH_RECIPE_IDS_BY_CATEGORY_ID($categoryId: Int = 1) {
  Recipe_Categories_Map(where: {Category_ID: {_eq: $categoryId}}) {
    recipe_category {
      name
    }
    Recipe_ID
  }
}
`;

export const FETCH_HOMEPAGE_CONFIG_AND_VERSION = gql`
  query FETCH_HOMEPAGE_CONFIG_AND_VERSION($userId: uuid = "") {
  User_Home_Config(where: {userId: {_eq: $userId}}) {
    mobile_config
    mobile_version
  }
}
`;


export const FETCH_ANNOUNCEMENT_CONFIG = gql`
  query FETCH_ANNOUNCEMENT_CONFIG($userId: uuid = "") {
  User_Home_Config(where: {userId: {_eq: $userId}}) {
    mobileAnnouncementConfig: mobile_announcement_config
    mobileAnnouncementVersion: mobile_announcement_version
  }
}
`;

export const GET_ALL_INGREDIENTS = gql`
  query GET_ALL_INGREDIENTS {
    ingredients: ${NEW_GET_INGREDIENTS}
  }
`;

export const NEW_GET_RECIPES = `
Recipes_E3(order_by: {name: asc}, where: {is_public: {_eq: true},is_deleted:{_eq:false}}) {
  id
  name
  active
  cuisine
  diet
  description
  meal_type
  hidden_tags
  created_source
  Recipe_Variations {
    cooking_time
    default
    description
    image_url
    max_serving
    min_serving
    prep_time
    ingredients
  }
}
`

export const GET_ALL_DATA = gql`
  query GET_ALL_DATA($userId: uuid = "",$userIdRecipes: String = "") {
    ingredients: ${NEW_GET_INGREDIENTS}
    recipes: ${NEW_GET_RECIPES}
  }
`

export const FETCH_PUBLIC_RECIPES_BY_CATEGORY = gql`
  query FETCH_PUBLIC_RECIPES_BY_CATEGORY($categoryIds: [Int!] = 10) {
    recipe_categories(where: {id: {_in: $categoryIds}}) {
      Recipe_Categories_Map {
        Category_ID
        Recipe_ID
        map_rank
        recipe_category {
          name
        }
      }
      id
    }
  }
`

export const FETCH_RECIPES_BY_CATEGORY_AND_INGREDIENTS = gql`
  query FETCH_RECIPES_BY_CATEGORY_AND_INGREDIENTS($categoryIds: [Int!] = 10, $diet: jsonb = "") {
    recipe_categories(where: {id: {_in: $categoryIds}}) {
      Recipe_Categories_Map(where: {Recipes_E3: {_and: {is_public: {_eq: true}, diet: {_contained_in: $diet}}}}) {
        Recipes_E3 {
          active
          author
          created_at
          created_by
          created_source
          cuisine
          description
          diet
          editor
          hidden_tags
          id
          last_edited_at
          is_public
          meal_type
          name
          recipe_market_price
          
          Recipe_Variations(where: {default: {_eq: true}}) {
            id
            image_url
            description
            default
            cooking_time
            active
            ingredients
            max_serving
            metadata
            min_serving
            name
            prep_time
            parameters
            recipe_id
            tags
          }
        }
        Category_ID
        Recipe_ID
        map_rank
        recipe_category {
          name
        }
      }
      id
    }
    Ingredients_DB(where: {created_source: {_eq: "recipeAdmin"}}, order_by: {displayName: asc}) {
        tags
        preps
        nutrientInfo
        image
        iconImage
        displayName
        defaultWeightUnit
        secondaryUnit
        defaultUnitTriggerPoint
        allergens
        approx
        alternateImage
        alternateNames
        conversion
        id: _id
        createdSource: created_source
    }
  }
`;

export const FETCH_RATINGS_SUMMARY_BY_RECIPE_ID = gql`
  query FETCH_RATINGS_SUMMARY_BY_RECIPE_ID($recipeId: String = "") {
    ratingsSummaryLast60DaysView(where: {recipeID: {_eq: $recipeId}}) {
      rating_avg
      rating_count
      recipeID
      top_feedback
    }
  }
`

export const FETCH_COOKING_HISTORY = gql`
  query FETCH_COOKING_HISTORY(
    $_eq: uuid!
    $_eq1: String!
    $offset: Int!
    $limit: Int!
  ) {
    Sessions_DB(
      where: { userID: { _eq: $_eq }, sessionType: { _eq: $_eq1 }, status: { _in: ["started", "completed", "ended"] } }
      limit: $limit
      offset: $offset
      order_by: {startTime: desc}
    ) {
      userID
      userComments
      status
      startTime
      updated_at
      show_comment
      sessionType
      sessionID
      recipeID
      rating
      endTime
      feedback
      feedback_images
      sessionRecipe {
        Recipe_Variations {
          image_url
        }
        name
        recipe_market_price
      }
    }
  }
`;

export const FETCH_RATINGS_SUMMARY_LAST_60_DAYS = gql`
  query FETCH_RATINGS_SUMMARY_LAST_60_DAYS {
    ratingsSummaryLast60DaysView {
      recipeID
      rating: rating_avg
      ratingCount: rating_count
    }
  }
`;

export const LAST_RATED_SESSION = gql`
  query LAST_RATED_SESSION($userId: uuid!) {
    Sessions_DB(
      where: {
        userID: { _eq: $userId }
        sessionType: { _eq: "recipe" }
        rating: { _gte: "3" }
        status: { _in: ["completed", "ended"] }
      }
      limit: 1
      order_by: { startTime: desc }
    ) {
      sessionID
      rating
    }
  }
`;

export const LAST_TWO_FIVE_STAR_SESSIONS = gql`
  query LAST_TWO_FIVE_STAR_SESSIONS($userId: uuid!) {
    Sessions_DB(
      where: {
        userID: { _eq: $userId }
        sessionType: { _eq: "recipe" }
        rating: { _eq: "5" }
        status: { _in: ["completed", "ended"] }
      }
      limit: 2
      order_by: { startTime: desc }
    ) {
      sessionID
      rating
      startTime
    }
  }
`;

export const FETCH_COOKING_HISTORY_SESSION_BY_ID = gql`
query FETCH_COOKING_HISTORY_SESSION_BY_ID($sessionID: String = "") {
  Sessions_DB_by_pk(sessionID: $sessionID) {
    userID
    userComments
    status
    startTime
    updated_at
    show_comment
    sessionType
    sessionID
    recipeID
    rating
    endTime
    feedback
    feedback_images
    sessionRecipe {
      Recipe_Variations(where: {}) {
        image_url
      }
      name
      recipe_market_price
    }
  }
}
`
export const FETCH_REVIEWS_BY_RECIPE_ID = gql`
query FETCH_REVIEWS_BY_RECIPE_ID($recipeId: String = "", $startTime_60daysAgo: timestamp = "") {
  Sessions_DB(where: {_and: [{rating: {_gte: "1"}}, {recipeID: {_eq: $recipeId}}, {sessionType: {_eq: "recipe"}}, {show_comment: {_eq: true}}, {startTime: {_gte: $startTime_60daysAgo}}], user: {email: {_nsimilar: "%upliance%|%reactlabs%"}}}, order_by: {startTime: desc}) {
    rating
    startTime
    userComments
    feedback
    user {
      nickName
      photoURL
    }
    sessionRecipe {
      name
    }
  }
}
`

export const FETCH_USER_UPLIANCE_REVIEW = gql`
  query FETCH_USER_UPLIANCE_REVIEW($user_id: uuid = "") {
    User_Upliance_Review(where: {user_id: {_eq: $user_id}}) {
      review_image
      review_text
    }
  }
`
export const GET_DEVICES_CONNECTED_TO_USER = gql`
query GET_DEVICES_CONNECTED_TO_USER($id: uuid = "") {
  users_by_pk(id: $id) {
    devices {
      id:_id
    }
  }
}
`

export const FETCH_USER_MEAL_PLAN = gql`
query FETCH_USER_MEAL_PLAN($userId: uuid = "", $allowedDiets: jsonb) {
  User_To_Meal_Plan(where: {user_id: {_eq: $userId}}) {
    user_id
    meal_plan_id
    Meal_Plan {
      author
      title
      description
      Meals(where: {Recipes_E3: {diet: {_contained_in: $allowedDiets}}}) {
        cooked_date_time
        id
        meal_type
        recipe_id
        scheduled_date_time
        serving_size
        status
        Recipes_E3 {
          id
          description
          cuisine
          author
          active
          created_source
          diet
          meal_type
          name
          Recipe_Variations (where: {default: {_eq: true}}) {
            image_url
            cooking_time
            prep_time
            max_serving
            min_serving
            metadata
            ingredients
          }
        }
      }
    }
  }
}
`
export const GET_RECIPE_INGREDIENTS = gql`
query GET_RECIPE_INGREDIENTS($_in: [String!] = "") {
  Ingredients_DB(order_by: {displayName: asc}, where: {_id: {_in: $_in}}) {
    tags
    preps
    nutrientInfo
    image
    iconImage
    displayName
    defaultWeightUnit
    secondaryUnit
    defaultUnitTriggerPoint
    allergens
    approx
    alternateImage
    alternateNames
    conversion
    id: _id
  }
}

`


export const GET_SHOPPING_LIST_ITEMS = gql`
  query GET_SHOPPING_LIST_ITEMS($where: Shopping_List_Item_bool_exp) {
    Shopping_List_Item(where: $where) {
      amount
      dateAdded: date_added
      id
      ingredientId: ingredient_id
      mealId: meal_id
      recipeId: recipe_id
      servingSize: serving_size
      shoppingListId: shopping_list_id
      status
      unit
    }
  }
`

export const FETCH_USER_GROCERY_LIST = gql`
   query FETCH_USER_GROCERY_LIST($user_id: uuid, $lte: timestamp, $gte: timestamp) {
    User_To_Shopping_List(where: {user_id: {_eq: $user_id}}) {
      shopping_list_id
      Shopping_List_Items(where: {Meal: {scheduled_date_time: {_lte: $lte, _gte: $gte}}}) {
        amount
        dateAdded: date_added
        id
        ingredientId: ingredient_id
        mealId: meal_id
        recipeId: recipe_id
        servingSize: serving_size
        shoppingListId: shopping_list_id
        status
        unit
        Ingredients_DB {
            tags
            preps
            nutrientInfo
            image
            iconImage
            displayName
            defaultWeightUnit
            secondaryUnit
            defaultUnitTriggerPoint
            allergens
            approx
            alternateImage
            alternateNames
            conversion
            id: _id
            created_source
        },
        Meal {
          scheduled_date_time
          Recipes_E3 {
            diet
            Recipe_Variations {
              ingredients
            }
          }
      }

      }
    }
  }
`
export const GET_RECIPE_AND_INGREDIENTS_GROCERY_LIST = gql`
query GET_RECIPE_AND_INGREDIENTS_GROCERY_LIST($recipeIds: [String!] = "") {
  Recipes_E3(where: {id: {_in: $recipeIds}}) {
    id
    Recipe_Variations(where: {default: {_eq: true}}) {
      RecipeVariations_Steps {
        StepsE3 {
          Steps_Substeps(where: {SubstepsE3: {type: {_eq: "ingredients"}}}) {
            SubstepsE3 {
              id
              parameters
            }
          }
        }
      }
    }
  }
}
`
export const GET_SHOPING_LIST_ID = gql`
query GET_SHOPING_LIST_ID($userId: uuid = "") {
  User_To_Shopping_List(where: {user_id: {_eq: $userId}}) {
    user_id
    shopping_list_id
  }
}
`


export const GET_MEALS_IN_TIMESTAMPS = gql`
query GET_MEALS_IN_TIMESTAMPS($userId: uuid = "", $_lte: timestamp = "", $_gte: timestamp = "") {
  users_by_pk(id: $userId) {
    Meal_Plans {
      Meals(where: {_and: [{scheduled_date_time: {_lte: $_lte}}, {scheduled_date_time: {_gte: $_gte}}]}) {
        id
      }
    }
  }
}
`

export const GET_MEALS_NOTES = gql`
  query GET_MEALS_NOTES($meal_plan_id: uuid = "") {
    Meal_Notes(where: {meal_plan_id: {_eq: $meal_plan_id}}) {
      content
      id
      meal_type
      scheduled_date_time
      status
    }
  }
`

export const GET_USER_NUTRITIONAL_TARGET = gql`
  query GET_USER_NUTRITIONAL_TARGET($user_id: uuid = "", $selectedDate: timestamp = "") {
    User_To_Nutritional_Info(
      where: {
        user_id: {_eq: $user_id},
        start_date: {_lte: $selectedDate},
        end_date: {_gte: $selectedDate}
      }
    ) {
      id
      nutritional_target
      start_date
      end_date
    }
  }

`

export const GET_USER_DEVICE_DATA = gql`
  query GET_USER_DEVICE_DATA($_eq: uuid = "") {
    users(where: {id: {_eq: $_eq}}) {
      devices {
        _id
        displayName
        metadata:__metadata
      }
    }
  }
`;